import { useQuery } from '@tanstack/react-query';
import { fetchAllGroups } from 'src/models/group/group';

import {
  BaseSelect,
  BaseSelectOption,
  SelectProps,
  createFormSelect,
} from './BaseSelect';

type GroupSelectProps = Omit<SelectProps, 'options' | 'loading'> & {
  filterOptions?: (
    options: BaseSelectOption[],
    { inputValue }: { inputValue: string }
  ) => BaseSelectOption[];
  platformId?: string;
  multiple?: boolean;
};

export const GroupSelect = ({
  filterOptions,
  multiple,
  ...props
}: GroupSelectProps) => {
  const { data: groups, isLoading } = useQuery({
    queryKey: ['groups', props.platformId],
    queryFn: () => fetchAllGroups(props.platformId),
    staleTime: 60000,
    gcTime: 60000,
  });

  const options = (groups || []).map((group) => ({
    id: group.id,
    label: group.name,
  }));

  return (
    <BaseSelect
      virtualized
      {...props}
      options={
        filterOptions ? filterOptions(options, { inputValue: '' }) : options
      }
      loading={isLoading}
      multiple={multiple}
    />
  );
};

export const FormGroupSelect = createFormSelect(GroupSelect);
